import React from "react";
import { getImage, handleDes, handleHeader } from "../utility.ts";
import Header from "./header.tsx";
import { useLocation, useNavigate } from "react-router-dom";

const Relationship = () => {
  const { state } = useLocation();
  const relationship = state.result;
  const navigate = useNavigate()

  const handleback = () =>{
    navigate('/')
  }
  return (
    <div className="card">
      <Header />
      <div className="cardinner">
        <h1 className="headerf">{handleHeader(relationship)}</h1>
        <img
          src={getImage(relationship)}
          alt={relationship}
          className="cardImg"
        />
        <h2 className="headerf">{handleDes(relationship)}</h2>
      </div>
      <button className= "backButton" onClick={handleback}>BACK</button>
    </div>
  );
};

export default Relationship;
